import React, { useState } from "react";
import * as url from "../../../../helpers/url_helper";
import { convertLocalDate } from "../../../../Utils/configController";
import LogsDataTable from "./LogsDataTable";

export interface ChipsControlProps {
  userId: any;
  selectedPremise?: any;
}

const DeviceList = ({ userId }: ChipsControlProps) => {
  const [loading, setLoading] = useState<boolean>(false);

  const columns = [
    {
      name: "Login Date & Time",
      selector: (row: any) => row?.createdAt || "",
      cell: (row: any) => (
        <div>{row?.createdAt ? convertLocalDate(row.createdAt) : "-"}</div>
      ),
      sortable: true,
      wrap: true,
      grow: 2,
    },
    {
      name: "Logout Date & Time",
      selector: (row: any) => row?.logoutDateTime || "",
      cell: (row: any) => (
        <div>
          {row?.logoutDateTime ? convertLocalDate(row.logoutDateTime) : "-"}
        </div>
      ),
      sortable: true,
      wrap: true,
      grow: 2,
    },
    {
      name: "OS",
      selector: (row: any) => row?.osName || "",
      cell: (row: any) => <div>{row?.osName || "-"}</div>,
      sortable: true,
      wrap: true,
      grow: 0.5,
    },
    {
      name: "Version",
      selector: (row: any) => row?.osVersion || "",
      cell: (row: any) => <div>{row?.osVersion || "-"}</div>,
      sortable: true,
      wrap: true,
      grow: 0.5,
    },
    {
      name: "App Version",
      selector: (row: any) => row?.appVersion || "",
      cell: (row: any) => <div>{row?.appVersion || "-"}</div>,
      sortable: true,
      wrap: true,
      grow: 1,
    },
    {
      name: "Mac Address",
      selector: (row: any) => row?.macAddress || "",
      cell: (row: any) => <div>{row?.macAddress || "-"}</div>,
      //   sortable: true,
      wrap: true,
      grow: 1.5,
    },
    {
      name: "Device Information",
      selector: (row: any) => row?.deviceInfo || "",
      cell: (row: any) => <div>{row?.deviceInfo || "-"}</div>,
      //   sortable: true,
      wrap: true,
      grow: 1.5,
    },
    {
      name: "Status",
      selector: (row: any) => (row?.isOnline ? "Online" : "Offline"),
      cell: (row: any) => (
        <span
          className={`font-size-11 badge bg-secondary ${
            row?.isOnline ? "badge-soft-success" : "badge-soft-danger"
          }`}
        >
          {row?.isOnline ? "Online" : "Offline"}
        </span>
      ),
      sortable: true,
      wrap: true,
      grow: 0.5,
    },
    {
      name: "User Token",
      selector: (row: any) => row?.id || "",
      cell: (row: any) => <div>{row?.id || "-"}</div>,
      //   sortable: true,
      wrap: true,
      grow: 2,
    },
  ];

  return (
    <div>
      <LogsDataTable
        apiURL={`${url.BASE_URL}${url.GET_DEVICE_LIST}`}
        title="Device List"
        columns={columns}
        loading={loading}
        setLoading={setLoading}
        userId={userId}
      />
    </div>
  );
};

export default DeviceList;
